<template>
    <div>

        <div class="card-body">

            <form method="post" autocomplete="off">

                <div v-if="errors">
                    <div v-for="error of errors" :key="error.message">
                        <div class="alert alert-dismissible fade show" role="alert" :class="error.type">
                            {{error.message}}

                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-3 col-sm-12">
                        <label for="id_number">Job Number:</label>
                        <input type="text" v-model="number" name="number" class="form-control mb-4" required id="id_number">
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <label for="id_title">Title:</label>
                        <input type="text" v-model="title" name="title" class="form-control mb-4" required id="id_title">
                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <label for="id_location">Location:</label>
                        <input type="text" v-model="location" name="location" class="form-control mb-4" required id="id_location">

                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-9 col-sm-12">
                        <label for="id_description">Description:</label>
                        <input type="text" v-model="description" name="description" class="form-control mb-4" required id="id_description">

                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <label for="id_project_manager">Project Manager:</label>
                        <select v-model="project_manager" type="text" name="number" class="form-control mb-4" required id="id_project_manager">
                            <option value="" selected>------------</option>
                            <option v-for="pm in pm_list" :key="pm.pk" :value="pm.pk">{{pm.first_name}} {{pm.last_name}}</option>
                        </select>

                    </div>
                </div>

                <label for="id_remarks">Remarks:</label>
                <textarea name="remarks" v-model="remarks" class="form-control mb-4" required id="id_remarks" cols="40" rows="6"/>

            </form>

        </div>


        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="resetDataClose"  data-toggle="tooltip" data-placement="top" title="Close the New Job Form">Cancel</button>

            <button type="button" class="btn" :class="[successful ? 'btn-success' : 'btn-primary']" @click="submitJob" :disabled="loading"  data-toggle="tooltip" data-placement="top" title="Submit New Job">
                <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"/>
                <span>{{buttonText}}</span>
                <font-awesome-icon v-if="successful" icon="check"/>
            </button>
        </div>

    </div>
</template>

<script>

    export default {
        name: "NewJob",
        data() {
            return {
                number: '',
                title: '',
                description: '',
                location: '',
                remarks: '',
                project_manager: '',
                active: true,
                // Button States
                successful: false,
                loading: false,
                // errors
                errors: []
            }
        },
        methods: {
            pushError(error) {
                this.removeError(error.message);
                this.errors.push(error)
            },
            removeError(error_message) {
                for( let i = 0; i < this.errors.length; i++) {
                    if ( this.errors[i].message === error_message) {
                        this.errors.splice(i, 1)
                    }
                }
            },
            submitJob() {

                this.loading = true;

                if(!this.validateJobName) {

                    this.pushError({
                        message: 'Job numbers can only contain letters, numbers, hyphens, or underscores',
                        type: 'alert-warning'
                    });

                    this.loading = false;
                    return false;
                }

                let payload = {
                    action: 'submitNewJob',
                    data: {
                        number: this.number,
                        title: this.title,
                        description: this.description,
                        location: this.location,
                        remarks: this.remarks,
                        project_manager: this.project_manager,
                        active: this.active
                    }
                };


                this.errors = [];

                this.$store.dispatch('tryRefresh', payload).then((response) => {

                    // eslint-disable-next-line no-console
                    console.log(response);
                    // Set input fields to default
                    this.loading = false;
                    this.successful = true;

                    setTimeout(() => {

                        this.$emit('jobSubmitted');

                        // Reset data and close
                        this.resetDataClose();

                    },500);



                }).catch(e => {
                    this.loading = false;
                    this.successful = false;

                    // eslint-disable-next-line no-console
                    console.log(e.response.data);

                    let errors = e.response.data;
                    let fields = Object.keys(errors);

                    // eslint-disable-next-line no-console
                    console.log(fields);

                    for(let i = 0; i < fields.length; i++){

                        let error_arr = errors[fields[i]];

                        for(let j = 0; j < error_arr.length; j++){
                            this.pushError({message: fields[i] + ': ' + error_arr[j], type: 'alert-warning'})
                        }
                    }


                })

            },
            resetDataClose() {

                this.$emit('closeModal');
                this.number = '';
                this.title = '';
                this.description = '';
                this.location = '';
                this.remarks = '';
                this.project_manager = '';
                this.active = true;
                this.successful = false;

                this.errors = [];

            },

        },
        computed: {
            buttonText: function() {
                if(this.loading) {
                    return 'Loading...'
                } else if(this.successful) {
                    return 'Success '
                } else {
                    return 'Create Job'
                }
            },
            pm_list: function () {
                return this.$store.getters.project_manager_list
            },
            validateJobName: function() {
                let re = /^[a-z0-9A-Z-]+$/;
                return re.test(this.number)
            },
        }
    }
</script>

<style scoped>

</style>